export default __webpack_public_path__ + "static/media/Leggings of the Deathstalker.3da51fc5.jpg";